import { Formik, Form } from "formik";
import React, { useState } from "react";
import OTPInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { routingConstants } from "@/Constants/routingConstants";
import { setUser } from "@/reducers/clientprofile";
import { _resendLoginOtp, _verifyLoginOtp } from "@/services/auth";
// import { router } from "@inertiajs/react";
import {
  handleAPICatch,
  showErrorToast,
  showSuccessToast,
} from "@/utilities/utils";

import { toggleSidebarsideBarCollapsed } from "../../../reducers/clientcommon";
import {
  setAllPermissions,
  setIsAuthenticated,
  setIsPremiumAccount,
  setSession,
} from "../../../reducers/session";
import { apiDecrypt, apiEncrypt } from "../../../utilities/keyEncryption";
import AuthButton from "../AuthButton";
import LoginFormTopContent from "../LoginFormTopContent";
/**
 * A function to resend the OTP.
 *
 * @param {object} values - The values to be used for OTP verification
 * @param {function} setSubmitting - The function to set the submitting state
 * @return {undefined} No return value
 */

const OtpVerificationForm = ({ email, user_id, APP_ENV }) => {
  const [otpResent, setOtpResent] = useState(false);
  const [reSending, setReSending] = useState(false);
  const [otp, setOtp] = useState("");
  const [disabledOtpBtn, setDisabledOtpBtn] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const { session } = useSelector((state) => state.session);
  const navigate = useNavigate();
  /**
   * A function to resend the OTP.
   */
  const resendOTP = () => {
    if (reSending) return;
    setReSending(true);
    const data = {
      user_id: user_id,
    };
    let response = _resendLoginOtp(data);
    response
      .then((res) => {
        let {
          status,
          data: { message },
        } = res;
        if (status === 200) {
          setReSending(false);
          setOtpResent(true);
          showSuccessToast(message);
        }
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        setReSending(false);
      });
  };

  const handleSubmitOTP = (values, { setSubmitting }) => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    values.otp = otp;
    if (values.otp.length === 0 || values.otp.length < 6) {
      showErrorToast(
        values.otp.length === 0 ? "Please enter OTP" : "Please enter valid OTP",
      );
      setIsSubmitting(false);
      return false;
    }
    setSubmitting(true);
    let response = _verifyLoginOtp(values);
    response
      .then((res) => {
        let { status, data } = res;
        if (status === 200) {
          const { user, token } = data;
          const { allPermission, is_confirm } = user;
          if (data) {
            if (is_confirm) {
              let userType = user.user_type;
              let userId = user.id ? apiDecrypt(user.id) : "";
              let firstname = user.firstname ? apiDecrypt(user.firstname) : "";
              let lastname = user.lastname ? apiDecrypt(user.lastname) : "";
              let roleName = user.role_name || "";
              let proileImg = user.profile_image
                ? apiDecrypt(user.profile_image)
                : "";

              let client_id = userType == "Agency" ? user.client_id : userId;
              let position_name =
                userType == "Agency"
                  ? user.position_name
                    ? apiDecrypt(user.position_name)
                    : ""
                  : "";
              let client_name = user.client_name || "";
              let allPermissions =
                userType == "Agency" ? user.allPermission : {};
              let isPrimaryContact =
                userType == "Agency" ? user.is_primary_contact : 1;
              let isViewTourGuide =
                userType == "Agency" ? user.is_view_user_tour : 1;
              let loggedInAs = userType == "Agency" ? user.login_as : "";
              let isBankClient = userType == "Agency" ? user.is_bank_client : 0;
              let is_main_client = user.is_main_client ? 1 : 0;
              let can_post_jobs = user.can_post_jobs ? 1 : 0;
              let can_approve_candidates = user.can_approve_candidates ? 1 : 0;
              let can_approve_timesheets = user.can_approve_timesheets ? 1 : 0;
              let can_process_payments = user.can_process_payments ? 1 : 0;

              let userToken = token.token ?? "";

              let visit_per = user.visit_per ?? "";
              let parking = user.parking ?? "";
              let food_drink = user.food_drink ?? "";
              let admin_per = user.admin_per ?? "";
              let vat_on_applocum_per = user.vat_on_applocum_per ?? "";
              let isHeadOffice = user.is_headoffice ?? "";
              let client_branches_temp = user.client_sub_branches ?? [];
              let managerName = user.client_manager_name ?? "";
              // let practiceCode = user.client_practice_code
              //   ? apiDecrypt(user.client_practice_code)
              //   : "";
              let qrCodeKey = user.qr_code ?? "";
              let qrCodeupdatedAt = user.qr_code_updated_at ?? "";
              let clientConsultantEmail = user.client_consultant_email
                ? apiDecrypt(user.client_consultant_email)
                : "";
              let clientUserEmail = user?.email ? apiDecrypt(user.email) : "";
              let clientAddress = user.client_address
                ? apiDecrypt(user.client_address)
                : "";
              let clientPhoneNumber = user.client_phone_number
                ? apiDecrypt(user.client_phone_number)
                : "";
              let clientRefNumber = user.client_ref_no
                ? apiDecrypt(user.client_ref_no)
                : "";
              let client_allow_publish_job = 0;
              let subscription_id = user.subscription_id ?? 1;

              // console.log(client_branches_temp)
              let client_branches = client_branches_temp.map((branch) => {
                return branch.id ? apiEncrypt(branch.id) : "";
              });
              client_branches = client_branches.filter(
                (branch) => branch !== "",
              );
              let sessionObj = {
                user_id: userId,
                user_type: userType,
                user_token: userToken,
                firstname,
                lastname,
                role_name: roleName,
                client_id: client_id,
                client_name: client_name,
                allPermissions: allPermissions,
                position_name: position_name,
                profile_image: proileImg,
                is_main_client: is_main_client,
                can_post_jobs: can_post_jobs,
                can_approve_candidates: can_approve_candidates,
                can_approve_timesheets: can_approve_timesheets,
                can_process_payments: can_process_payments,
                visit_per: visit_per,
                parking: parking,
                food_drink: food_drink,
                admin_per: admin_per,
                vat_on_applocum_per: vat_on_applocum_per,
                is_headoffice: isHeadOffice,
                client_sub_branches: client_branches,
                client_manager_name: managerName,
                // client_practice_code: practiceCode,
                qr_code_key: qrCodeKey,
                qr_code_updated_at: qrCodeupdatedAt,
                qr_code: "", // qr code implementation will go here
                client_consultant_email: clientConsultantEmail,
                client_user_email: clientUserEmail,
                client_address: clientAddress,
                client_phone_number: clientPhoneNumber,
                client_ref_number: clientRefNumber,
                is_primary_contact: isPrimaryContact,
                is_view_user_tour: isViewTourGuide,
                login_as: loggedInAs,
                // is_bank_client: isBankClient,
                // client_allow_publish_job: client_allow_publish_job,
                // subscription_id: subscription_id,
                client_allow_publish_job: 1,
                subscription_id: 2,
                is_bank_client: 0,
                client_allow_appchat_broadcast: 1,
                client_allow_e_compliance: 1,
              };
              dispatch(setIsPremiumAccount(true));
              dispatch(setAllPermissions(allPermission));
              dispatch(setSession(sessionObj));
            }
          }
          dispatch(setUser(data.user));
          dispatch(setIsAuthenticated(true));
          dispatch(toggleSidebarsideBarCollapsed(true));
          if (data.user.user_type == "Candidate") {
            // router.visit(route("candidate.dashboard"));
          } else if (data.user.user_type == "Client") {
            // console.log("client");
            // window.location.href = routingConstants.dashboard;
          } else {
            navigate(routingConstants.dashboard);
            // console.log("client user");
            // router.visit(routingConstants.login);
          }
        }
      })
      .catch((error) => {
        // console.log("error", error);
        handleAPICatch(error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="auth_form_wrapper">
      <Formik
        initialValues={{
          user_id: user_id,
        }}
        validateOnChange={false}
        validateOnBlur={false}
        validateOnMount={false}
        onSubmit={(values, { setSubmitting }) => {
          handleSubmitOTP(values, { setSubmitting });
        }}
      >
        {({ submitForm, isValid }) => (
          <Form className="flex flex-col gap-6">
            <LoginFormTopContent
              title={"OTP Verification"}
              desc={
                APP_ENV === "local" || APP_ENV === "development"
                  ? "Please enter all Zeroes (000000) as OTP in below boxes"
                  : `Please enter the OTP that has been sent to your email (${email}) in the boxes below.`
              }
            />
            <div>
              <div className="grid gap-4">
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  containerStyle={
                    "otp-input-wrapper w-full m-auto flex justify-between mb-[20px] gap-1"
                  }
                  inputType="number"
                  renderInput={(props, index) => (
                    <input
                      {...props}
                      autoFocus={index === 0 ? true : false}
                      className="!w-[45px] !select-none !px-[0px] !shadow-[0_2px_4px_rgba(194,194,194,0.5215686275)] outline-none"
                      onKeyDown={(e) => {
                        if (index === 5 && e.keyCode === 13) {
                          submitForm();
                          if (document.activeElement != document.body)
                            document.activeElement.blur();
                        }
                      }}
                    />
                  )}
                />
              </div>
              <div className="mt-2 text-right">
                <p className="!text-[14px] font-medium leading-[normal]">
                  Didn't receive an OTP?{" "}
                  <span
                    className="authLink inline-block !text-[14px] !font-medium !text-primary"
                    onClick={() => {
                      if (reSending) return;
                      setReSending(true);
                      resendOTP();
                    }}
                  >
                    {reSending ? "Resending" : "Resend"}
                  </span>
                </p>
              </div>
              <div className="input-group">
                <input type="hidden" name="recaptcha" id="recaptcha" />
              </div>
              <AuthButton
                submitForm={submitForm}
                isSubmitting={isSubmitting}
                isValid={isValid}
                btnText={"Submit OTP"}
                btnLoadingText={"Submitting"}
                disabled={isSubmitting}
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default OtpVerificationForm;
